<template>
  <div class="GlobalTable">
    <div style="margin-bottom: 10px;display: flex;align-items: center;justify-content: space-between;">
      <GardenSlwct
        :tab-data="tabData"
        :activeIndex="activeIndex"
        border-radius="40px"
        @tabAction="tabAction"
      >
      </GardenSlwct>
      <el-button size="small" type="warning" slot="AddSlot" @click="exportData"
          >导出数据</el-button
        >
    </div>
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column label="品牌" slot="productBrand" align="center">
        <template slot-scope="{ row }">
          <span>{{row.productBrand}}</span>
        </template>
      </el-table-column>
      <el-table-column label="机型" slot="modelMemory" align="center" v-if="mold == '1'">
        <template slot-scope="{ row }">
          <span>{{row.modelMemory}}</span>
        </template>
      </el-table-column>
      <el-table-column label="查询类型" slot="type" align="center" v-if="mold != '3'">
        <template slot-scope="{ row }">
          <span>{{row.type}}</span>
        </template>
      </el-table-column>
      <el-table-column label="查询结果" slot="merchantType" align="center">
        <template slot-scope="{ row }">
          <span class="text-down" @click="openResultDia(row)">查看</span>
        </template>
      </el-table-column>
      <el-table-column label="传输终端零售价" slot="retailPrice" align="center"  v-if="mold == '1'">
        <template slot-scope="{ row }">
          <span>{{row.retailPrice}}</span>
        </template>
      </el-table-column>
    </GlobalTable>
    <!-- 查询结果 -->
    <el-dialog
      title="查询结果"
      :visible.sync="resultVisible"
      :close-on-click-modal="false"
      width="600px"
    >
     <div style="margin-bottom: 20px">
      <GlobalTable
        ref="GlobalTable"
        :loading="resultLoading"
        :columns="resultColumns"
        :data="dialogResultList"
        :isPagination="false"
        :maxHeight="625"
      >
        <el-table-column
          label="结果"
          slot="shopState"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>{{ row.val ||"--"}}</span>
          </template>
        </el-table-column>
      </GlobalTable>
     </div>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import {queryImei,queryResult,queryImeiDown} from "../../../utils/request/changePhone";
import GardenSlwct from "@/components/common/GardenSlwct.vue";

export default {
  name: "Table",
  components: { GardenSlwct },
  data() {
    return {
      activeIndex: 0,
      mold: "1",
      tabData: [
        {
          text: "终端零售价查询",
          value: "1",
          hideNum: true,
        },
        {
          text: "旧机ID查询",
          value: "2",
          hideNum: true,
        },
        {
          text: "品牌查询",
          value: "3",
          hideNum: true,
        },
         {
          text: "激活查询",
          value: "4",
          hideNum: true,
        },
      ],
      btnLoading: false,
      resultVisible: false,
      resultLoading: false,
      currentRow: {},
      dialogResultList: [],
      resultColumns: [
        { label: "查询内容", prop: "title" },
        { slotName: "shopState" },
      ],
      loading: false,
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      tableColumns: [
        { label: "查询串号", prop: "imei" },
        { slotName: "productBrand" }, //查询结果
        { slotName: "modelMemory" }, //查询结果
        { slotName: "type" }, //查询结果
        { slotName: "merchantType" }, //查询结果
        { label: "费用", prop: "cost" },
        { label: "查询服务商", prop: "channel" },
        { slotName: "retailPrice" },
        { label: "查询时间", prop: "add_time" },
      ],
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  created() {
    this.handleCurrentChange();
  },
  watch: {
    SeachParams(newVal) {
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
  },
  methods: {
    tabAction(val) {
      this.activeIndex = val;
      this.mold = this.tabData[val].value
      this.handleCurrentChange(1)
    },
    // 查询结果
    searchResult() {
      this.resultLoading = true;
      queryResult({id:this.currentRow.id,mold: this.mold}).then((res) => {
        if (res.code === 1) {
          this.dialogResultList = res.data;
          this.resultLoading = false;
        }
      });
    },
    openResultDia(row) {
      this.currentRow = row;
      this.resultVisible = true;
      this.searchResult();
    },
    // 表格切换页面
    handleCurrentChange(val) {
      console.log("列表查询");
      if (val) {
        this.page.pageNum = val;
      }
      const baseRequest = {
        mold: this.mold,
        imei: this.SeachParams.imei,
        brand: this.SeachParams.brand,
        channel: this.SeachParams.channel,
        beg_time: this.SeachParams.beg_time,
        end_time: this.SeachParams.end_time,
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };

      this.loading = true;
      queryImei(baseRequest).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data;
          this.page.total = Number(res.count);
          this.page.pageNum = Number(res.page);
          this.loading = false;
        }
      }).finally(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    exportData() {
      const baseRequest = {
        mold: this.mold,
        imei: this.SeachParams.imei,
        brand: this.SeachParams.brand,
        channel: this.SeachParams.channel,
        beg_time: this.SeachParams.beg_time,
        end_time: this.SeachParams.end_time,
      };
      queryImeiDown(baseRequest).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        const fileName = "串号查询明细.xls";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">

.GlobalTable {
  .flex {
    display: flex;
    align-items: center;
  }
}

.text-down {
  color: #0981ff;
  cursor: pointer;
  text-decoration: underline;
}
</style>
